import {
  BENEFITS_ERROR,
  BENEFITS_SUCCESS,
  BENEFITS_LOADING,
  EXCHANGES_ERROR,
  EXCHANGES_SUCCESS,
  EXCHANGES_LOADING,
  CATEGORIES_ERROR,
  CATEGORIES_SUCCESS,
  CATEGORIES_LOADING,
  CURRENT_CATEGORY_SUCCESS,
  CURRENT_PRODUCT_CATEGORY_SUCCESS,
  POINTS_ERROR,
  POINTS_SUCCESS,
  POINTS_LOADING,
  BALANCE_ERROR,
  BALANCE_SUCCESS,
  BALANCE_LOADING,
  PRODUCTS_BY_CATEGORY_ERROR,
  PRODUCTS_BY_CATEGORY_SUCCESS,
  PRODUCTS_BY_CATEGORY_LOADING,
  OPEN_PRODUCT_MODAL_SUCCESS,
  NEW_EXCHANGE_SUCCESS,
  NEW_EXCHANGE_ERROR,
  NEW_EXCHANGE_LOADING,
} from '../types/BankTypes';
import {
  callGetBankBenefits,
  callGetCustomerExchanges,
  callGetBankCategories,
  callGetCustomerPoints,
  callGetProductsByCategory,
  callCreateCustomerExchange,
} from '../../services/BankService';
import { callGetGiftcardBalance } from '../../services/GiftCardService';
import { errorMessage, successMessage } from './FlashActions';

const loadBenefits = () => {
  return {
    type: BENEFITS_LOADING,
  };
};

const errorInBenefits = () => {
  return {
    type: BENEFITS_ERROR,
  };
};

const setBenefits = (benefits) => {
  return {
    type: BENEFITS_SUCCESS,
    benefits,
  };
};

const loadExchanges = () => {
  return {
    type: EXCHANGES_LOADING,
  };
};

const errorInExchanges = () => {
  return {
    type: EXCHANGES_ERROR,
  };
};

const setExchanges = (exchanges) => {
  return {
    type: EXCHANGES_SUCCESS,
    exchanges,
  };
};

const loadCreateExchange = () => {
  return {
    type: NEW_EXCHANGE_LOADING,
  };
};

const setNewExchange = (newExchange) => {
  return {
    type: NEW_EXCHANGE_SUCCESS,
    newExchange,
  };
};

const errorInCreateExchange = () => {
  return {
    type: NEW_EXCHANGE_ERROR,
  };
};

const loadCategories = () => {
  return {
    type: CATEGORIES_LOADING,
  };
};

const errorInCategories = () => {
  return {
    type: CATEGORIES_ERROR,
  };
};

const setCategories = (categories) => {
  return {
    type: CATEGORIES_SUCCESS,
    categories,
  };
};

const setCurrentCategory = (currentCategory) => {
  return {
    type: CURRENT_CATEGORY_SUCCESS,
    currentCategory,
  };
};

const setCurrentProductCategory = (currentProductCategory) => {
  return {
    type: CURRENT_PRODUCT_CATEGORY_SUCCESS,
    currentProductCategory,
  };
};

export const setOpenProductModal = (openProductModal) => {
  return {
    type: OPEN_PRODUCT_MODAL_SUCCESS,
    openProductModal,
  };
};

const loadPoints = () => {
  return {
    type: POINTS_LOADING,
  };
};

const errorInPoints = () => {
  return {
    type: POINTS_ERROR,
  };
};

const setPoints = (points) => {
  return {
    type: POINTS_SUCCESS,
    points,
  };
};

const loadBalance = () => {
  return {
    type: BALANCE_LOADING,
  };
};

const errorInBalance = () => {
  return {
    type: BALANCE_ERROR,
  };
};

const setBalance = (balance) => {
  return {
    type: BALANCE_SUCCESS,
    balance,
  };
};

const loadProductsByCategory = () => {
  return {
    type: PRODUCTS_BY_CATEGORY_LOADING,
  };
};

const errorInProductsByCategory = () => {
  return {
    type: PRODUCTS_BY_CATEGORY_ERROR,
  };
};

const setProductsByCategory = (productsByCategory) => {
  return {
    type: PRODUCTS_BY_CATEGORY_SUCCESS,
    productsByCategory,
  };
};

export const getBankBenefits = () => {
  return async (dispatch) => {
    dispatch(loadBenefits());
    try {
      const res = await callGetBankBenefits();
      if (res.status !== 200) dispatch(errorInBenefits());
      else dispatch(setBenefits(res.data));
    } catch (error) {
      dispatch(errorInBenefits());
    }
  };
};

export const getCustomerExchange = () => {
  return async (dispatch, getState) => {
    dispatch(loadExchanges());
    try {
      const { logonId } = getState().profileReducer.profile;
      const res = await callGetCustomerExchanges(logonId);
      if (res.status !== 200) dispatch(errorInExchanges());
      else dispatch(setExchanges(res.data));
    } catch (e) {
      dispatch(errorInExchanges());
    }
  };
};

const createCustomerExchangeErrors = (res) => {
  switch (res.data.id) {
    case 'EXCHANGE_06':
      return 'El número de documento ingresado no es válido, por favor intenta nuevamente.';
    case 'EXCHANGE_07':
      return 'Lo sentimos, el producto no está disponible. Disculpa los inconvenientes.';
    default:
      return 'Lo sentimos, estamos presentando inconvenientes para realizar tu canje. Por favor, intenta nuevamente.';
  }
};

export const createCustomerExchange = (documentNumber) => {
  return async (dispatch, getState) => {
    dispatch(loadCreateExchange());
    try {
      const { logonId } = getState().profileReducer.profile;
      const currentProductCategory = getState().bankReducer
        .currentProductCategory;

      const res = await callCreateCustomerExchange(logonId, {
        documentNumber: documentNumber,
        productId: currentProductCategory.id,
      });

      if (res.status !== 200) {
        dispatch(errorInCreateExchange());
        dispatch(errorMessage(createCustomerExchangeErrors(res)));
      } else {
        dispatch(setNewExchange(res.data));
        dispatch(successMessage('Canje realizado exitosamente.'));
      }
    } catch (e) {
      dispatch(errorInCreateExchange());
      dispatch(
        errorMessage(
          'Hubo un problema para ejecutar el canje, intenta nuevamente.',
        ),
      );
    }
  };
};

export const getBankCategories = () => {
  return async (dispatch) => {
    dispatch(loadCategories());
    try {
      const res = await callGetBankCategories();
      if (res.status !== 200) dispatch(errorInCategories());
      else dispatch(setCategories(res.data));
    } catch (e) {
      dispatch(errorInCategories());
    }
  };
};

export const getCurrentBankCategory = (currentCategory) => {
  return async (dispatch) => {
    dispatch(setCurrentCategory(currentCategory));
  };
};

export const getCurrentProductCategory = (currentProductCategory) => {
  return async (dispatch) => {
    dispatch(setCurrentProductCategory(currentProductCategory));
  };
};

export const getCustomerPoints = () => {
  return async (dispatch, getState) => {
    dispatch(loadPoints());
    try {
      const { logonId } = getState().profileReducer.profile;
      const res = await callGetCustomerPoints(logonId);
      if (res.status == 200)
        dispatch(
          setPoints({
            ...res.data,
            subscribed: true,
          }),
        );
      else if (res.status == 404)
        dispatch(
          setPoints({
            subscribed: false,
          }),
        );
      else dispatch(errorInPoints());
    } catch (e) {
      dispatch(errorInPoints());
    }
  };
};

export const getBalanceForGCFromClient = (cardNumber) => {
  return async (dispatch) => {
    dispatch(loadBalance());
    try {
      const res = await callGetGiftcardBalance(cardNumber);
      if (res.status !== 200 || res.data.error.codigo !== 0)
        dispatch(errorInBalance());
      else dispatch(setBalance(res.data));
    } catch (e) {
      dispatch(errorInBalance());
    }
  };
};

export const getProductsByCategory = (category) => {
  return async (dispatch) => {
    dispatch(loadProductsByCategory());
    try {
      const res = await callGetProductsByCategory(category);

      if (res.status !== 200) dispatch(errorInProductsByCategory());
      else dispatch(setProductsByCategory(res.data));
    } catch (e) {
      dispatch(errorInProductsByCategory());
    }
  };
};
